import { gql } from '$lib/apollo';
import { TESTIMONIAL_FIELDS } from './testimonials';

export const GET_CONNECTED_ACCOUNTS = gql`
  query GetConnectedAccounts {
    currentSession {
      id
      discord {
        id
        username
        discriminator
        hasLatestPermissions
      }
      twitch {
        id
        username
      }
      apple {
        id
      }
      facebook {
        id
      }
      google {
        id
        email
        isCalendarLinked
        calendarAdd
        calendarConflicts
      }
      patreon {
        id
      }
    }
  }
`;

export const GET_ABOUT_SETTINGS = gql`
  query GetAboutSettings {
    currentSession {
      id
      name
      slug
      avatar {
        original {
          url
        }
      }
      email
      bio
      cover {
        original {
          url
        }
      }
      country
      timezone
      languages
    }
  }
`;

export const GET_COACH_FAQ_SETTINGS = gql`
  query GetCoachFaqSettings {
    currentSession {
      id
      faqs {
        id
        question
        answer
        position
      }
    }
  }
`;

export const GET_FAQS_SETTINGS = gql`
  query GetFaqsSettings {
    currentSession {
      id
      faqs {
        id
        question
        answer
        position
      }
    }
  }
`;

export const GET_ACHIEVEMENT_SETTINGS = gql`
  query GetAchievementSettings {
    currentSession {
      id
      achievements {
        id
        type
        achievement
        tournamentTitle
        placement
        year
        position
        game {
          id
          slug
          localizedShortTitles {
            en
          }
          localizedTitles {
            en
          }
          logoMain {
            original {
              url
            }
          }
        }
      }
    }
  }
`;

export const GET_COACH_AVAILABILITY_SETTINGS = gql`
  query GetCoachAvailabilitySettings {
    currentSession {
      id
      isAfk
      afkEndDate
      optimizedScheduling
      bookingNotice {
        unit
        value
      }
      google {
        id
        email
        isCalendarLinked
        calendarAdd
        calendarConflicts
      }
      availability {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
      dailyLimitMinutes {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
    }
  }
`;

export const GET_COACH_TESTIMONIAL_SETTINGS = gql`
  query GetTestimonialSettings(
    $writtenFirst: Int = 20
    $writtenAfter: String
    $videoFirst: Int = 0
    $videoAfter: String
  ) {
    currentSession {
      id
      writtenTestimonials: testimonials(
        type: WRITTEN
        first: $writtenFirst
        after: $writtenAfter
        sort: [{ on: FEATURED_POSITION, direction: ASCENDING }, { on: CREATED_AT, direction: DESCENDING }]
      ) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...TestimonialFields
            featuredPosition
          }
        }
      }
      videoTestimonials: testimonials(
        type: VIDEO
        first: $videoFirst
        after: $videoAfter
        sort: [{ on: FEATURED_POSITION, direction: ASCENDING }, { on: CREATED_AT, direction: DESCENDING }]
      ) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...TestimonialFields
            featuredPosition
          }
        }
      }
    }
  }
  ${TESTIMONIAL_FIELDS}
`;
